import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form, Input, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import CrudButtons from "components/button/crudbuttons";
import { Send } from "lucide-react";
import {
    getTicketDetails,
    doTicketCreate,
} from "../../../../redux/supportticket/supportticketState";

export const DEPT_ID = 161;

const SupportTicket = ({
    onCancel,
    getRecord,
    recordData, 
	requesting, 
	success,
    doCreate, 
	doUpdate, 
    ...props
}) => {
    const { recordId, mode } = props;
    const [form] = Form.useForm();

    useEffect(() => {
        getRecord(recordId);
    }, [getRecord, recordId]);

    const onSubmit = (formData) => {
        try {
            formData.prefix = 'IT';
            formData.tic_department_id = DEPT_ID;

            recordData.tic_id > 0 ? doUpdate(formData): doCreate(formData); 
        } catch (error) {
            console.error('Save failed:', error);
        }
    };

    return (
        <Card className="p-0">
            <Form
                form={form}
                className={mode !== "view" ? "form" : ""}
                layout="vertical" 
                onFinish={onSubmit}
            >
                <div>
                    <div className="space-y-2">
                        <FormItem
                            name="tic_title_id" 
                            label="Issue Title"
                            rules={[requiredField()]}
                        >
                            <Select id="tic_title_id"
                                allowClear={true}
                                className="input-field"
                                options={recordData?.ITtitles}
                                placeholder="Brief description of the issue"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_category_id" 
                            label="Category"
                            rules={[requiredField()]}
                        >
                            <Select id="tic_category_id"
                                allowClear={true}
                                className="input-field"
                                options={recordData?.ITcategory}
                                placeholder="Select category"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_priority_id" 
                            label="Priority"
                            rules={[requiredField()]}
                        >
                            <Select id="tic_priority_id"
                                allowClear={true}
                                className="input-field"
                                options={recordData?.priority}
                                placeholder="Select priority"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_description"
                            label="Details"
                            rules={[requiredField()]}
                        >
                            <TextArea
                                id="tic_description" 
                                className="input-field"
                                maxLength={255}
                                placeholder="Provide details about your issue..."
                                rows={3}
                            />
                        </FormItem>
                    </div>
                    <div className="flex gap-2 pt-2 flex-row-reverse">
                        <CrudButtons
                            mode={mode}
                            recordId={recordData?.tic_id ?? 0}
                            isModal={true}
                            modalId={recordData?.tic_id > 0 ? "edit_ticket" : "add_ticket"}
                            doHideModal={onCancel}
                            cancelLabel="Cancel"
                            submitLabel="Submit Ticket"
                            moduleId={0}
                            cancelIcon=""
                            submitIcon={<Send className="w-4 h-4 mr-2" />}
                            submitClassName="ticket submit-ticket blue"
                            cancelClassName="ticket cancel-ticket"
                        />
                    </div>
                </div>
            </Form>
        </Card>
    )
};
const mapStateToProps = (state) => ({
    recordData: state.ticket.ticketDetails?.data,
    requesting: state.ticket.ticketDetails?.requesting,
    success: state.ticket.ticketDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getTicketDetails(id)),
    doCreate: (data) => dispatch(doTicketCreate(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SupportTicket);